<template>
    <transition-slide-toggle>
        <div class="notification" v-if="show">
            <div class="container">
                <div class="alert alert-danger d-flex justify-content-between align-items-center">
                    {{ alert.title }}
                    <button type="button" class="close text-right" aria-label="Sluiten" @click="markSeen" v-show="show">
                        <span class="fas fa-times-circle" aria-hidden="true"></span>
                    </button>
                </div>
            </div>
        </div>
    </transition-slide-toggle>
</template>

<script>
    export default {
        props: {
            alert: Object,
        },
        data() {
            return {
                show: false,
                timestamp: this.alert['datum.timestamp'],
                storageKey: 'alert-seen',
            }
        },
        created() {
            // check op zowel "heb ik al gezien en weggeklikt" en of de alert uberhaupt nog getoond moet worden
            if (this.timestamp > this.seenUntil() && this.alert.should_show) {
                this.show = true;
            }
        },
        methods: {
            seenUntil() {
                return this.$localStorage.get(this.storageKey);
            },
            markSeen() {
                this.show = false;
                this.$localStorage.set(this.storageKey, this.timestamp);
            }
        }
    }
</script>
